<a [routerLink]="link" *ngIf="!displayValidateFixedMenu">
<div class="fixed-menu">{{"edit_your_experience_button" | translate}}</div>
</a>


<a (click)="validateExperience()"  *ngIf="displayValidateFixedMenu" [class.isDisabled]="disabledButton">
  <div class="fixed-menu ">{{"validate_experience_button" | translate}}</div>
</a>
